/**
 * Whether a list has more behind its "view all" link than it already shows.
 * An unknown total counts as more, so the link stays.
 */
export const hasMoreThanShown = (totalCount: number | undefined, shownCount: number): boolean =>
  typeof totalCount !== 'number' || totalCount > shownCount
